<template>
    <return-button class="return-button" />
    <div class="main-container">
        <div class="info-paciente">
            <h2 class="titulos">Información del paciente</h2>
            <div
                v-for="(item, index) in mostrarItemsPaciente"
                :key="index"
                style="
                    display: grid;
                    grid-template-columns: 1fr auto 1fr;
                    align-items: center;
                    text-align: center;
                ">
                <span style="text-align: right" class="indicador"
                    >{{ item.indicador }}
                </span>
                <span style="padding: 0 5px">:</span>
                <span style="text-align: left" class="valor">
                    {{ item.valor }}</span
                >
            </div>
        </div>
        <h2 class="titulos" style="text-align: center">
            Información del historial médico
        </h2>
        <v-col>
            <v-row class="mr-4 ml-4 mt-4" no-gutters>
                <v-col cols="12" md="" class="d-flex justify-start mb-1">
                    <h2 class="titulos">Diagnósticos</h2>
                </v-col>
            </v-row>
            <v-row v-if="errorEmpty">
                <v-col>
                    <div class="error-message">
                        {{ errorEmpty }}
                    </div>
                </v-col>
            </v-row>
            <v-row v-else style="justify-content: left">
                <v-col class="d-flex justify-start">
                    <v-timeline
                        side="end"
                        align="start"
                        justify="left"
                        truncate-line="start"
                        line-color="#4CABD3">
                        <v-timeline-item
                            v-for="diagnose in diagnoses"
                            :key="diagnose._key"
                            :dot-color="diagnose.status ? '#4CABD3' : '#FFC107'"
                            size="small">
                            <span class="indicador">Fecha: </span>
                            <span class="fecha">{{ diagnose.created_at }}</span>
                            <br />
                            <p
                                v-for="disease in diagnose.disease"
                                :key="disease._key">
                                <span
                                    class="disease"
                                    v-html="disease.diseaseName"></span>
                                &nbsp;
                                <span v-if="disease.diseaseId">ICD ID:</span>
                                <span class="disease-id">
                                    {{ disease.diseaseId }}
                                </span>
                            </p>
                            <span class="indicador">Medicamentos: </span>
                            <ul
                                v-for="(
                                    medication, index
                                ) in diagnose.requestedMedications"
                                :key="index">
                                <li>
                                    {{ medication }}
                                </li>
                            </ul>
                        </v-timeline-item>
                    </v-timeline>
                </v-col>
            </v-row>
        </v-col>
    </div>
</template>

<script>
import returnButton from '@/components/global/return-button.vue';
import { getPatientById } from '@/api/pacientes';
import { getDiagnoses } from '@/api/historia_clinica'
import { formDate } from '@/utils/converte_date';

export default {
    methods: {
        // Muestra el contendio del expedieten (la lista de medicamentos recetados
        fetchDiagnoses() {
            let id = this.$route.params.id;
            getDiagnoses(id)
                .then((response) => {
                    response.forEach((element) => {
                        element.created_at = formDate(element.created_at);
                    });
                    this.diagnoses = response;
                    if (response.length === 0) {
                        this.errorEmpty = 'No se encontraron diagnósticos';
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        fetchPatientDetails() {
            let id = this.$route.params.id;

            getPatientById(id)
                .then((patient) => {
                    this.mostrarItemsPaciente = [
                        { indicador: 'Nombre', valor: patient.nombre },
                        {
                            indicador: 'Apellido',
                            valor:
                                patient.primerApellido +
                                    ' ' +
                                    patient.segundoApellido ?? null,
                        },
                        {
                            indicador: 'Fecha de nacimiento',
                            valor: patient.birthdate,
                        },
                        { indicador: 'Edad', valor: patient.edad },
                        { indicador: 'Sexo', valor: patient.sexo },
                    ];
                    this.fetchDiagnoses();
                })
                .catch((error) => {
                    console.error(error);
                });
        },
    },
    mounted() {
        this.selectedPatientId = this.$route.params.id;
    },
    created() {
        this.fetchPatientDetails();
    },
    components: {
        'return-button': returnButton,
    },
    data() {
        return {
            items: [],
            dialogo: false,
            errorEmpty: null,
            selectedPatientId: null,
            selectedRecipeId: null,
            recipeData: null,
            mostrarItemsPaciente: [],
            rowsPerPage: 10,
            formattedDate: '',
            patientId: this.$route.params.id,
            diagnoses: null,
        };
    },
};
</script>

<style scoped>
.cont-botones {
    gap: 5px;
    display: flex;
    align-items: center;
}

.indicador {
    color: var(--color-principal);
}

.font {
    color: white;
}

.info-paciente {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;
}

.customize-table {
    background-color: var(--color-principal);
    color: white;
}

.operation-icon {
    color: var(--color-principal);
    cursor: pointer;
}

.operation-icon:hover {
    color: var(--color-principal);
}

.span {
    color: var(--color-principal);
}

.operation-wrapper {
    display: flex;
    align-items: center;
}

.operation-icon {
    cursor: pointer;
}

.error-message {
    color: var(--color-error);
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
}

.disease-id {
    color: var(--color-principal);
}
</style>
